import type { IInvestigationReport } from '@apis/investigationReports';
import { RecentCardShell } from './RecentCardShell';
import styles from './RecentCardShell.module.css';

interface IDefaultRecentCardProps {
  submission: IInvestigationReport;
  siteId: string;
}

/**
 * Fallback card used by the rail when a report type doesn't register a
 * dedicated `RecentCard`. Renders the record's `description` in the
 * meta-row middle slot — the user's note (with the report's i18n
 * subtitle as the default).
 */
export function DefaultRecentCard({ submission, siteId }: IDefaultRecentCardProps) {
  return (
    <RecentCardShell
      reportType={submission.investigationType}
      reportId={submission.reportId}
      siteId={siteId}
      createdAtIso={submission.dateGeneratedIso}
      title={submission.title}
    >
      <span className={styles.subtitle}>{submission.description}</span>
    </RecentCardShell>
  );
}
